// extracted by mini-css-extract-plugin
export default {"cell":"CourseBrowseSection_cell__5qfc8","rating":"CourseBrowseSection_rating__5tmmU"};